import {ErrorCodes} from './error'
import {getUseSharedState} from '~/utils/getUseSharedState'

export const useOverlays = getUseSharedState<[id: number, Component: React.FunctionComponent][]>([])

export type OnDone<T> = {onDone: (...values: [] | [T]) => void}
export type ComponentWithOnDone<T> = React.FunctionComponent<OnDone<T>>

export function openOverlay<T = void>(Component: ComponentWithOnDone<T>, signal?: AbortSignal) {
    let removeOverlay: () => void = Boolean

    const promise = new Promise<T>((resolve, reject) => {
        const handleOnDone = (...values: [] | [T]) =>
            values.length
                ? resolve(values[0])
                : reject({code: ErrorCodes.userCancel})

        removeOverlay = addOverlay(() => <Component onDone={handleOnDone}/>)
    })

    Promise.race([
        promise,
        new Promise(resolve => signal?.addEventListener('abort', resolve, {once: true})),
    ])
        .finally(removeOverlay)
        .catch(Boolean)

    return promise
}

let id = 0

export function addOverlay(Component: React.FunctionComponent) {
    const overlayId = id++

    useOverlays.dispatch([
        ...useOverlays.getState(),
        [overlayId, Component],
    ])

    return () => useOverlays.dispatch(
        useOverlays
            .getState()
            .filter(([id]) => id != overlayId)
    )
}
